import { Injectable } from '@angular/core';
import { State } from '../interfaces/state.interface';
import { VoteMap } from '../interfaces/votemap.interface';
import { DeviationCalculator } from '../calculators/deviation.calculator';

@Injectable({
  providedIn: 'root',
})
export class VoteProcessingService {
  processVotes(currentState: State): VoteMap {
    let voteMap: VoteMap = JSON.parse("{}");
    voteMap.voteFrequencyMap = this.createPlayerVoteMap(currentState);
    voteMap.average = this.calculateAverage(voteMap.voteFrequencyMap);
    voteMap.deviation = this.calculateDeviation(voteMap.voteFrequencyMap);
    voteMap.mostVotedCardKey = this.findMostVotedCard(voteMap.voteFrequencyMap);

    return voteMap;
  }

  private findMostVotedCard(votes: Map<number, number>): number {
    if (votes == null) {
      return null;
    }

    let mostVotedCardKey: number = -1;
    let highestCardFrequency: number = -1;

    votes.forEach((voteCardFrequency: number, voteCardKey: number) => {
      if (voteCardFrequency == highestCardFrequency) {
        mostVotedCardKey = -1;
      }
      else if (voteCardFrequency > highestCardFrequency) {
        mostVotedCardKey = voteCardKey;
        highestCardFrequency = voteCardFrequency;
      }
    });

    return mostVotedCardKey;
  }

  private createPlayerVoteMap(currentState: State): Map<number, number> {
    let voteMap: Map<number, number> = new Map();

    for (let i = 0; i < currentState.Votes.length; i++) {
      let cardValue: any = currentState.Votes[i].Card;

      if (cardValue == "1/2") {
        cardValue = 0.5;
      }

      if (isNaN(cardValue) || cardValue == null) {
        continue;
      }

      let key: number = Number(cardValue);
      if (voteMap.has(key)) {
        voteMap.set(key, voteMap.get(key) + 1)
      } else {
        voteMap.set(key, 1)
      }
    }

    return voteMap;
  }

  private getSumOfVotes(voteMap) {
    let sumOfVotes: number = 0;

    voteMap.forEach((value, key) => {
      if (key == "1/2") {
        sumOfVotes += 0.5 * value;
      }
      else {
        sumOfVotes += key * value;
      }
    });

    return sumOfVotes;
  }

  private countVotes(votes: Map<number, number>): number {
    let countVotes: number = 0;

    votes.forEach((value) => {
      countVotes += Number(value);
    });

    return countVotes;
  }

  private calculateAverage(votes: Map<number, number>) {
    let averageOfVotes: number = 0;
    averageOfVotes = Math.floor((this.getSumOfVotes(votes) / this.countVotes(votes)) * 10) / 10;

    if (isNaN(averageOfVotes)) {
      averageOfVotes = 0;
    }

    return averageOfVotes;
  }

  private calculateDeviation(votes: Map<number, number>): number {
    let votedCards: Array<number> = new Array<number>();

    votes.forEach((key, value) => {
      for (let i: number = 0; i < key; i++) {
        votedCards.push(value);
      }
    });

    let deviation = DeviationCalculator.calculateDeviation(votedCards);

    return !isNaN(deviation) ? Math.round(deviation * 10) / 10 : 0;
  }

  private isNumber(value: any): boolean {
    return !isNaN(value) && isFinite(value);
  }
}
